import { defineMessages } from 'react-intl';

export const messages: {
	disclaimer: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	disclaimer: {
		id: 'conversation-assistant-message-actions.atlassian-project-status-update-action-renderer.card-footer.disclaimer',
		defaultMessage:
			"May include information some users don't have permission to view. Review for sensitive or restricted content before sharing this update.",
		description:
			'Disclaimer in the project status update card footer about content visibility and reviewing before sharing.',
	},
});
